/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button.btn.btn-dropdown[_ngcontent-%COMP%]{display:flex;flex-flow:row nowrap;align-items:center}button.btn.btn-dropdown[_ngcontent-%COMP%]   div.selected_name[_ngcontent-%COMP%]{max-width:13rem;overflow:hidden;text-overflow:ellipsis;flex:0 1 auto}button.btn.btn-dropdown[_ngcontent-%COMP%]::after{display:block;flex:0 0 auto}"];
export { styles as styles };
